import React from "react";
import { useHistory } from "react-router";
import { activeUserService } from "../../services/index";
import Utils from "../../utility/index"




export default function verifyEmailPage(props) {
  const url = props.ticket

  async function PostVerifyEmail(user) {
    // let [error, verified] =
    await Utils.parseResponse(
      activeUserService.verifyEmailOnDb({userId:user})
    );
    return true;
  };
  let userId=props.data
  return (
    <div>
        <center>
            <p>to confirm your account <span><a href="#" onClick={async (props)=>{
              await PostVerifyEmail({userId})
              window.location.href = url;
              } }>click here</a></span></p>
        </center>
    </div>
  );
}

